import { Component, OnInit, Output, Input, EventEmitter, ElementRef, Injector, ChangeDetectionStrategy } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';

@Component({
  selector: 'app-auto-complete-query',
  template: require('./auto-complete-query.component.html'),
  styles: [require('./auto-complete-query.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AutoCompleteQueryComponent extends UpgradeComponent {

  @Input() query;
  @Output() queryChange = new EventEmitter();

  @Input() words: any;
  @Input() error: any;
  @Output() executeQuery = new EventEmitter<any>();

  // TODO this is an angularJS component upgraded to Angular component
  constructor(elementRef: ElementRef, injector: Injector) {
    super('autoCompleteQuery', elementRef, injector);
  }

}